import { Routes, Route, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";
import { Layout } from "./components/Layout";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Login } from "./pages/Login";
import { Dashboard } from "./pages/Dashboard";
import { SearchFixtures } from "./pages/SearchFixtures";
import { Report } from "./pages/Report";
import { History } from "./pages/History";
import { Bookmakers } from "./pages/Bookmakers";
import { Settings } from "./pages/Settings";
import { CoverageScreen } from "./real/CoverageScreen";
import { DemoProvider, useDemo } from "./context/DemoContext";
import { AuthProvider } from "./context/AuthContext";
import { RealDataProvider } from "./lib/real-store";

const ValueOdds = lazy(() => import("./pages/ValueOdds").then(({ ValueOdds }) => ({ default: ValueOdds })));
const MatchesPage = lazy(() => import("./real/ReferenceScreens").then(({ MatchesPage }) => ({ default: MatchesPage })));
const MarketAnalysisPage = lazy(() => import("./real/ReferenceScreens").then(({ MarketAnalysisPage }) => ({ default: MarketAnalysisPage })));
const CompetitionsPage = lazy(() => import("./real/ReferenceScreens").then(({ CompetitionsPage }) => ({ default: CompetitionsPage })));
const TeamsPage = lazy(() => import("./real/ReferenceScreens").then(({ TeamsPage }) => ({ default: TeamsPage })));
const InsightsPage = lazy(() => import("./real/ReferenceScreens").then(({ InsightsPage }) => ({ default: InsightsPage })));
const MatchDetailsPage = lazy(() => import("./real/ReferenceScreens").then(({ MatchDetailsPage }) => ({ default: MatchDetailsPage })));
const ChatPage = lazy(() => import("./real/ReferenceScreens").then(({ ChatPage }) => ({ default: ChatPage })));

function LiveModule({ children }: { children: React.ReactNode }) {
  const { isDemo, toggleDemo } = useDemo();
  if (!isDemo) return <>{children}</>;
  return <section className="card p-6 reference-demo-gate"><p className="eyebrow">MÓDULO COM DADOS REAIS</p><h1 className="text-xl font-semibold mt-2">Saia do modo demonstração para continuar</h1><p className="text-sm text-[var(--color-text-muted)] mt-2 mb-4">Agenda, catálogo, Insights e Chat usam partidas e snapshots reais do seu workspace. O modo Demo continua isolado dessas telas.</p><button className="btn btn-primary" type="button" onClick={toggleDemo}>Voltar aos dados reais</button></section>;
}

function App() {
  return (
    <AuthProvider>
      <DemoProvider>
        <RealDataProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/" element={<Layout />}>
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="partidas" element={<LiveModule><Suspense fallback={<p role="status">Abrindo agenda…</p>}><MatchesPage /></Suspense></LiveModule>} />
                <Route path="partidas/odds-de-valor" element={
                  <Suspense fallback={<p className="text-[var(--color-text-muted)]" role="status">Abrindo Odds de valor…</p>}>
                    <ValueOdds />
                  </Suspense>
                } />
                <Route path="match/:fixtureId" element={<LiveModule><Suspense fallback={<p role="status">Abrindo partida…</p>}><MatchDetailsPage /></Suspense></LiveModule>} />
                <Route path="analysis" element={<LiveModule><Suspense fallback={<p role="status">Abrindo análise…</p>}><MarketAnalysisPage /></Suspense></LiveModule>} />
                <Route path="campeonatos" element={<LiveModule><Suspense fallback={<p role="status">Abrindo campeonatos…</p>}><CompetitionsPage /></Suspense></LiveModule>} />
                <Route path="times" element={<LiveModule><Suspense fallback={<p role="status">Abrindo times…</p>}><TeamsPage /></Suspense></LiveModule>} />
                <Route path="insights" element={<LiveModule><Suspense fallback={<p role="status">Calculando insights…</p>}><InsightsPage /></Suspense></LiveModule>} />
                <Route path="chat" element={<LiveModule><Suspense fallback={<p role="status">Abrindo chat…</p>}><ChatPage /></Suspense></LiveModule>} />
                <Route path="search" element={<SearchFixtures />} />
                <Route path="report/:analysisId" element={<Report />} />
                <Route path="history" element={<History />} />
                <Route path="value-odds" element={
                  <Suspense fallback={<p className="text-[var(--color-text-muted)]" role="status">Abrindo Odds de valor…</p>}>
                    <ValueOdds />
                  </Suspense>
                } />
                <Route path="bookmakers" element={<Bookmakers />} />
                <Route path="coverage" element={<CoverageScreen />} />
                <Route path="settings" element={<Settings />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </RealDataProvider>
      </DemoProvider>
    </AuthProvider>
  );
}

export default App;
